import { render, staticRenderFns } from "./CidField.vue?vue&type=template&id=057bf8a4&scoped=true"
import script from "./CidField.vue?vue&type=script&lang=js"
export * from "./CidField.vue?vue&type=script&lang=js"
import style0 from "./CidField.vue?vue&type=style&index=0&id=057bf8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057bf8a4",
  null
  
)

export default component.exports